import { Timestamp } from '@angular/fire/firestore';

export enum LogType {
	Login = 'login',
	Logout = 'logout',
	PasswordChange = 'passwordChange',
	PasswordReset = 'passwordReset',
	Signup = 'signup',
	Info = 'info',
	Error = 'error',
	Warning = 'warning',
	PersonalDataUpdate = 'personalDataUpdate',
	ProfilePicUpdate = 'profilePicUpdate',
}

export interface Log {
	id: string;
	type: LogType;
	message: string;
	createdAt: Timestamp;
	data?: Record<string, unknown>;
}
